import { FC } from 'react'
import classnames from 'classnames'

type SpinProps = {
  className?: string
  hint?: string | null
  alwaysHint?: boolean
}

const Spin: FC<SpinProps> = ({ className = 'spinner-holder', hint = null, alwaysHint = false }) => {
  const classes = classnames(className, {
    'hint hint--top hint--timetoast': hint !== null,
    'hint--always': alwaysHint,
  })

  return (
    <div role="status" aria-live="polite" className={classes} data-hint={hint}>
      <div className="spinner"></div>
    </div>
  )
}

export default Spin
